import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { LineChartData } from '../../models/common.model';

@Component({
  selector: 'app-growth-score-graph',
  templateUrl: './growth-score-graph.component.html',
  styleUrls: ['./growth-score-graph.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GrowthScoreGraphComponent {
  @Input() growthScoreGraph: LineChartData;
}
